module.exports = __webpack_public_path__ + "img/product_1.9bcca9bf.jpg";